module.exports = __webpack_public_path__ + "img/proyecto_17.0786acbb.png";